import { RootState } from 'store/store';
import { createSelector } from '@reduxjs/toolkit';

export const organizersStoreSelector = (state: RootState) => state.organizers;
export const selectOrganizersOptions = createSelector(organizersStoreSelector, (state) => state);
export const selectOrganizerById = (id: number) =>
  createSelector(organizersStoreSelector, (state) => state.organizers.find((item) => item.id === id));
export const selectActiveOrganizerPlans = (tournamentId: number) =>
  createSelector([organizersStoreSelector], (state) => state.plans.byOwnerId[tournamentId]);

export const selectPlansList = createSelector([organizersStoreSelector], (state) => state.plans.list);
